import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class IndexRoute extends Route {
  @service
  router;

  activate() {
    // Redirect to "current" page, so that there's actually content to show!
    let params = this.paramsFor('group');
    this.router.transitionTo(
      'group.insights.assessments.current.index',
      params.group_id,
    );
  }
}
